export const PREFIX = 'DIET_DIARIES_REPORT';
